module.exports = __webpack_public_path__ + "static/media/li.c60b16a0.svg";